import { useEffect } from "react"

const APP_NAME = "Task Board"

/** Sets `document.title` for the current page. Restores the previous title on unmount. */
export function usePageTitle(title: string) {
  useEffect(() => {
    const previous = document.title
    document.title = `${title} · ${APP_NAME}`
    return () => {
      document.title = previous
    }
  }, [title])
}
